function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  'use strict';

  // Configuration
  // Initialization
  // Page Data
  // Filter Editor
  // - Simple Editor
  //   - Filter Utils
  //     - generic filter methods
  //     - filter config methods
  //     - Activities Util
  //     - People Util
  //     - Groups Util
  //     - Verbs Util
  //     - Dates Util
  //     - Permissions Util
  // - Advanced Editor
  // Save Filter Modal
  // Validation
  // Preview
  angular.module('wsLrs.controllers').controller('FilterEditorCtrl', ['$scope', '$routeParams', '$q', 'Api', '$http', '$location', 'ConfirmModal', 'FilterPermissionSvc', 'CustomFilters', 'FilterRegistry', 'Logger', 'CardRegistry', 'TinCanJS', 'Utils', function ($scope, $routeParams, $q, Api, $http, $location, ConfirmModal, PermissionSvc, CustomFilters, FilterRegistry, Logger, CardRegistry, TinCanJS, Utils) {
    // -------------------------------
    // Configuration
    // -------------------------------
    Utils.setIn($scope, ['filter'], {});
    Utils.setIn($scope, ['advancedConfig'], false);
    Utils.setIn($scope, ['utils'], {});
    Utils.setIn($scope, ['noneCategory'], {
      name: "None",
      id: null
    });

    // Activity toggle control
    $scope.cfg = {};
    $scope.cfg.activitySearchToggleSelect = {
      options: [{
        text: "Activity IDs and Names (default)",
        searchPlaceholder: "Search by Activity IDs and Names (default)",
        state: "include_ids",
        default: true,
        selected: true
      }, {
        text: "Activity IDs only",
        searchPlaceholder: "Search by Activity IDs only",
        state: "exclude_names",
        default: false,
        selected: false
      }, {
        text: "Activity Names only",
        searchPlaceholder: "Search by Activity Names only",
        state: "exclude_ids",
        default: false,
        selected: false
      }],
      selectedOption: {
        text: "Activity IDs and Names (default)",
        searchPlaceholder: "Search by Activity IDs and Names (default)",
        state: "include_ids",
        default: true,
        selected: true
      },
      isDefaultSelected: true,
      dropdownOpen: false
    };

    // -------------------------------
    // Initialization
    // -------------------------------
    var filterId = $routeParams.filterId;
    var editPeople = [];
    var editGroups = [];
    var editPermissions = [];
    Utils.setIn($scope, ['editPeopleAndGroups'], []);
    Utils.setIn($scope, ['permissionsChanged'], false);
    Utils.setIn($scope, ['filterChanged'], false);
    if (filterId !== 'new' && _.isFinite(filterId)) {
      $http.get(Api.url("/filters/" + filterId), {
        params: {
          countReports: true
        }
      }).then(function (r) {
        Utils.setIn($scope, ['filter'], r.data);
        Utils.setIn($scope, ['originalEntity'], angular.copy(r.data));
        Utils.setIn($scope, ['originalName'], $scope.filter.name);
        PermissionSvc.fetchPermissions().then(function getPermissionsSuccess() {
          Utils.setIn($scope, ['filter', 'permissions'], PermissionSvc.get(filterId));
          editPeople = _.clone(Utils.getIn($scope, ['filter', 'permissions', 'people']));
          editGroups = _.clone(Utils.getIn($scope, ['filter', 'permissions', 'groups']));
          editPermissions = _.clone(Utils.getIn($scope, ['filter', 'permissions', 'permissions']));
          Utils.setIn($scope, ['editPeopleAndGroups'], [].concat(editPeople, editGroups));
        });
        fetchEditorData(Utils.getIn($scope, ['filter'])).then(prepareSelectedFilters);
      });
    } else {
      var copyFilter = $routeParams.copy;
      if (copyFilter) {
        if (_.isFinite(copyFilter)) {
          $http.get(Api.url("/filters/" + copyFilter)).then(function (r) {
            Utils.setIn($scope, ['filter'], r.data);
            delete $scope.filter.id; // todo: deleteIn($scope, ['filter', 'id'])
            delete $scope.filter.created; // todo: deleteIn($scope, ['filter', 'created'])
            delete $scope.filter.updated; // todo: deleteIn($scope, ['filter', 'updated'])
            Utils.setIn($scope, ['filter', 'name'], 'Copy of ' + $scope.filter.name);
            fetchEditorData(Utils.getIn($scope, ['filter'])).then(prepareSelectedFilters);
          });
        } else {
          copyFilter = JSON.parse(copyFilter);
          Utils.setIn($scope, ['filter', 'name'], 'Copy of ' + copyFilter.name);
          Utils.setIn($scope, ['filter', 'visibility'], 'everyone');
          Utils.setIn($scope, ['filter', 'config'], copyFilter);
          fetchEditorData(Utils.getIn($scope, ['filter'])).then(prepareSelectedFilters);
        }
      } else {
        Utils.setIn($scope, ['filter'], {
          visibility: 'everyone',
          config: {}
        });
        fetchEditorData(Utils.getIn($scope, ['filter'])).then(prepareSelectedFilters);
      }
    }
    Utils.setIn($scope, ['visibilities'], [{
      id: "everyone",
      name: "Everyone with Permission"
    }, {
      id: "none",
      name: "Hidden"
    }]);

    // ctrl initialization
    initEditorControls();

    // util initialization
    initFilterUtils();
    initPermissionsUtil();

    // preview initialization
    initPreview();

    // -------------------------------
    // Page Data
    // -------------------------------
    function fetchEditorData() {
      var includedPersonIds = getIncludedPeopleInFilter({
        alt: []
      });
      var excludedPersonIds = getExcludedPeopleInFilter({
        alt: []
      });
      var includedGroupIds = getIncludedGroupsInFilter({
        alt: []
      });
      var excludedGroupIds = getExcludedGroupsInFilter({
        alt: []
      });
      var includedVerbIds = getIncludedVerbsInFilter({
        alt: []
      });
      var excludedVerbIds = getExcludedVerbsInFilter({
        alt: []
      });
      return $q.all([fetchCategoriesData(), fetchActivitiesData(), fetchPeopleData([].concat(_toConsumableArray(includedPersonIds), _toConsumableArray(excludedPersonIds))), fetchGroupData([].concat(_toConsumableArray(includedGroupIds), _toConsumableArray(excludedGroupIds))), fetchVerbData([].concat(_toConsumableArray(includedVerbIds), _toConsumableArray(excludedVerbIds)))]);
    }
    function fetchCategoriesData() {
      $http.get(Api.url("/filter-categories")).then(function (r) {
        $scope.categories = r.data.results;
        $scope.categories.unshift($scope.noneCategory);
        if ($scope.filter.filterCategoryName) {
          $scope.filter.filterCategory = _.findWhere($scope.categories, {
            name: $scope.filter.filterCategoryName
          });
        } else {
          $scope.filter.filterCategory = $scope.noneCategory;
        }
      });
    }
    function fetchActivitiesData() {
      var searchParams = {
        searchTerm: "",
        order_by: "name",
        searchToggle: $scope.cfg.activitySearchToggle
      };
      $http.get(Api.url("/acc/activities/search"), {
        params: searchParams
      }).then(function (r) {
        Utils.setIn($scope, ['activities'], {}); // question: use a Map instead? && move to init phase
        r.data.results.forEach(function (activity) {
          return Utils.setIn($scope, ['activities', activity.activityId], activity);
        });
      });
    }
    function fetchPeopleData(personIds) {
      return $http.get(Api.url('people/multi'), {
        params: {
          "ids": personIds
        }
      }).then(function (_ref) {
        var people = _ref.data.results;
        return people.forEach(function (person) {
          return Utils.setIn($scope, ['people', person.id], person);
        });
      });
    }
    function fetchGroupData(groupIds) {
      return $http.get(Api.url('groups/multi'), {
        params: {
          "ids": groupIds
        }
      }).then(function (_ref2) {
        var groups = _ref2.data.results;
        return groups.forEach(function (group) {
          return Utils.setIn($scope, ['groups', group.id], group);
        });
      });
    }
    function fetchVerbData(verbIds) {
      return $http.get(Api.url('acc/verbs/multi/by-verb-id'), {
        params: {
          "verbIds": verbIds
        }
      }).then(function (_ref3) {
        var verbs = _ref3.data.results;
        return verbs.forEach(function (verb) {
          return Utils.setIn($scope, ['verbs', verb.verbId], verb);
        });
      });
    }

    // -------------------------------
    // Filter Editor
    // -------------------------------
    function initEditorControls() {
      Utils.setIn($scope, ['save'], save);
      Utils.setIn($scope, ['saveAsCopy'], saveAsCopy);
      initSimpleEditorControls();
      // todo: initAdvancedEditorControls();
    }
    function setEditor() {
      var modifiedEditorFilter = angular.copy($scope.filter);
      delete modifiedEditorFilter.filterCategory;
      delete modifiedEditorFilter.permissions;
      $scope.editor.setValue(angular.toJson(modifiedEditorFilter, 2), -1);
    }
    function save(isCopy) {
      updateFilterFromAceEditor();
      if (validate()) {
        openSaveModal(isCopy);
      }
    }
    function saveAsCopy() {
      $scope.save(true);
    }

    // -------------------------------
    // Simple Editor
    // -------------------------------
    function showSimple() {
      Utils.setIn($scope, ['advancedConfig'], false);
      updateFilterFromAceEditor();
      fetchEditorData(Utils.getIn($scope, ['filter'])).then(prepareSelectedFilters);
    }
    function initSimpleEditorControls() {
      Utils.setIn($scope, ['showSimple'], showSimple);
    }

    // -------------------------------
    // Filter Utils
    // -------------------------------
    function initFilterUtils() {
      Utils.setIn($scope, ['getFilterTypeahead'], getFilterTypeahead);
      initActivityUtils();
      initPeopleUtils();
      initGroupsUtils();
      initVerbUtils();
    }
    function prepareSelectedFilters() {
      prepareSelectedActivities();
      prepareSelectedGroups();
      prepareSelectedPeople();
      prepareSelectedVerbs();
    }
    function getFilterTypeahead(key, val) {
      // todo: save results
      if (!key) {
        return [];
      }

      //TODO: implement searching for people, groups and activities by other fields (ids, descriptions etc)
      switch (key) {
        case "verbIds":
          return $http.get(Api.url('/acc/verbs'), {
            params: {
              in_display: val,
              order_by: "display",
              _limit: 10
            }
          }).then(function (r) {
            return _.map(r.data.results, function (d) {
              return {
                id: d.verbId,
                name: d.display
              };
            });
          });
        case "activityIds":
          var searchParams = {
            searchTerm: val,
            order_by: "name",
            searchToggle: $scope.cfg.activitySearchToggle,
            _limit: 10
          };
          return $http.get(Api.url('/acc/activities/search'), {
            params: searchParams
          }).then(function (r) {
            return _.map(r.data.results, function (d) {
              return {
                activityId: d.activityId,
                id: d.activityId,
                name: d.name
              };
            });
          });
        case "personIds":
          return $http.get(Api.url('people'), {
            params: {
              "in_name": val,
              "order_by": "name",
              "_limit": 10
            }
          }).then(function (r) {
            return r.data.results;
          });
        case "groupIds":
          // todo: fix this name, (should be groupsNames?)
          return $http.get(Api.url("/groups"), {
            params: {
              "in_name": val,
              "order_by": "name",
              "_limit": 10
            }
          }).then(function (r) {
            return r.data.results;
          });
        default:
          //equals filter
          return [];
      }
    }

    // ------------------------------
    // generic filter methods
    // ------------------------------
    function getActivityIds(filter) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        alt = _ref4.alt;
      return Utils.getIn(filter, ['activityIds', 'ids'], {
        alt: alt
      });
    }
    function hasActivityIds(filter) {
      return !!getActivityIds(filter, {
        alt: false
      });
    }
    function putActivityIds(filter, ids) {
      Utils.setIn(filter, ['activityIds', 'ids'], ids, {
        force: true
      });
      return filter;
    }
    function getPersonIds(filter) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        alt = _ref5.alt;
      return Utils.getIn(filter, ['personIds'], {
        alt: alt
      });
    }
    function hasPersonIds(filter) {
      return !!getPersonIds(filter, {
        alt: false
      });
    }
    function putPersonIds(filter, ids) {
      Utils.setIn(filter, ['personIds'], ids, {
        force: true
      });
      return filter;
    }
    function getGroupIds(filter) {
      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        alt = _ref6.alt;
      return Utils.getIn(filter, ['groupIds'], {
        alt: alt
      });
    }
    function hasGroupIds(filter) {
      return !!getGroupIds(filter, {
        alt: false
      });
    }
    function putGroupIds(filter, ids) {
      Utils.setIn(filter, ['groupIds'], ids, {
        force: true
      });
      return filter;
    }
    function getVerbIds(filter) {
      var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        alt = _ref7.alt;
      return Utils.getIn(filter, ['verbIds', 'ids'], {
        alt: alt
      });
    }
    function hasVerbIds(filter) {
      return !!getVerbIds(filter, {
        alt: false
      });
    }
    function putVerbIds(filter, ids) {
      Utils.setIn(filter, ['verbIds', 'ids'], ids, {
        force: true
      });
      return filter;
    }

    // -------------------------------
    // filter config methods
    // -------------------------------
    // notOr in filter
    function getNotOrFilter() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        alt = _ref8.alt;
      return Utils.getIn($scope, ['filter', 'config', 'not', 'or'], {
        alt: alt
      });
    }
    function setNotOrFilter(filters) {
      return Utils.setIn($scope, ['filter', 'config', 'not', 'or'], filters, {
        force: true
      });
    }

    // activities included in filter
    function getIncludedActivitiesInFilter() {
      var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        alt = _ref9.alt;
      return Utils.getIn($scope, ['filter', 'config', 'activityIds', 'ids'], {
        alt: alt
      });
    }
    function hasIncludedActivitiesInFilter() {
      return !!getIncludedActivitiesInFilter({
        alt: false
      });
    }
    function setIncludedActivitiesInFilter(activityIds) {
      if (activityIds.length === 0 && hasIncludedActivitiesInFilter()) {
        var config = Utils.getIn($scope, ['filter', 'config']);
        delete config.activityIds; // todo: deleteIn($scope, ['filter', 'config', 'activityIds'])
      } else {
        Utils.setIn($scope, ['filter', 'config', 'activityIds', 'ids'], activityIds, {
          force: true
        });
      }
    }

    // activities excluded in filter
    function getExcludedActivitiesInFilter() {
      var _ref0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        alt = _ref0.alt;
      var notOrFilter = getNotOrFilter({
        alt: []
      });
      var activityFilter = notOrFilter.find(hasActivityIds);
      return activityFilter ? getActivityIds(activityFilter) : alt;
    }
    function hasExcludedActivitiesInFilter() {
      return !!getExcludedActivitiesInFilter({
        alt: false
      });
    }
    function remFirstExcludedActivitiesInFilter() {
      if (hasExcludedActivitiesInFilter()) {
        var notOrFilter = getNotOrFilter({
          alt: []
        });
        var activityFilterIndex = notOrFilter.findIndex(hasActivityIds);
        setNotOrFilter(notOrFilter.slice(0, activityFilterIndex).concat(notOrFilter.slice(activityFilterIndex + 1)));
      }
    }
    function pushExcludedActivitiesInFilter(ids) {
      var notOrFilter = getNotOrFilter({
        alt: []
      });
      var activityIds = putActivityIds({}, ids);
      setNotOrFilter([activityIds].concat(_toConsumableArray(notOrFilter)));
    }
    function setExcludedActivitiesInFilter(ids) {
      remFirstExcludedActivitiesInFilter();
      pushExcludedActivitiesInFilter(ids);
    }

    // people & groups exclusion
    function getExcludedPeopleOrGroupsInFilter() {
      var _ref1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        alt = _ref1.alt;
      var notOrFilter = getNotOrFilter({
        alt: []
      });
      var pgFilter = notOrFilter.find(function (x) {
        return hasPersonIds(x) || hasGroupIds(x);
      });
      return pgFilter ? pgFilter : alt;
    }
    function hasExcludedPeopleOrGroupsInFilter() {
      return !!getExcludedPeopleOrGroupsInFilter({
        alt: false
      });
    }
    function remFirstExcludedPeopleOrGroupsInFilter() {
      if (hasExcludedPeopleOrGroupsInFilter()) {
        var notOrFilter = getNotOrFilter({
          alt: []
        });
        var pgFilterIndex = notOrFilter.findIndex(function (x) {
          return hasPersonIds(x) || hasGroupIds(x);
        });
        setNotOrFilter(notOrFilter.slice(0, pgFilterIndex).concat(notOrFilter.slice(pgFilterIndex + 1)));
      }
    }
    function pushExcludedPeopleOrGroupsInFilter() {
      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref10$personIds = _ref10.personIds,
        personIds = _ref10$personIds === void 0 ? [] : _ref10$personIds,
        _ref10$groupIds = _ref10.groupIds,
        groupIds = _ref10$groupIds === void 0 ? [] : _ref10$groupIds;
      var notOrFilter = getNotOrFilter({
        alt: []
      });
      var pgFilter = putGroupIds(putPersonIds({}, personIds), groupIds);
      setNotOrFilter([pgFilter].concat(_toConsumableArray(notOrFilter)));
    }
    function setExcludedPeopleOrGroupsInFilter() {
      var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref11$personIds = _ref11.personIds,
        personIds = _ref11$personIds === void 0 ? [] : _ref11$personIds,
        _ref11$groupIds = _ref11.groupIds,
        groupIds = _ref11$groupIds === void 0 ? [] : _ref11$groupIds;
      remFirstExcludedPeopleOrGroupsInFilter();
      pushExcludedPeopleOrGroupsInFilter({
        personIds: personIds,
        groupIds: groupIds
      });
    }

    // people included in filter
    function getIncludedPeopleInFilter() {
      var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        alt = _ref12.alt;
      return Utils.getIn($scope, ['filter', 'config', 'personIds'], {
        alt: alt
      });
    }
    function hasIncludedPeopleInFilter() {
      return !!getIncludedPeopleInFilter({
        alt: false
      });
    }
    function setIncludedPeopleInFilter(personIds) {
      if (personIds.length === 0 && hasIncludedPeopleInFilter()) {
        var config = Utils.getIn($scope, ['filter', 'config']);
        delete config.personIds; // todo: deleteIn($scope, ['filter', 'config', 'personIds'])
      } else {
        Utils.setIn($scope, ['filter', 'config', 'personIds'], personIds, {
          force: true
        });
      }
    }

    // people excluded in filter
    function getExcludedPeopleInFilter() {
      var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        alt = _ref13.alt;
      var pgFilter = getExcludedPeopleOrGroupsInFilter({
        alt: false
      });
      if (!!pgFilter && hasPersonIds(pgFilter)) {
        return getPersonIds(pgFilter);
      }
      return alt;
    }
    function setExcludedPeopleInFilter(personIds) {
      if (hasExcludedPeopleOrGroupsInFilter()) {
        var pgFilter = getExcludedPeopleOrGroupsInFilter();
        setExcludedPeopleOrGroupsInFilter({
          personIds: personIds,
          groupIds: getGroupIds(pgFilter)
        });
      } else {
        pushExcludedPeopleOrGroupsInFilter({
          personIds: personIds
        });
      }
    }

    // groups included in filter
    function getIncludedGroupsInFilter() {
      var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        alt = _ref14.alt;
      return Utils.getIn($scope, ['filter', 'config', 'groupIds'], {
        alt: alt
      });
    }
    function hasIncludedGroupsInFilter() {
      return !!getIncludedGroupsInFilter({
        alt: false
      });
    }
    function setIncludedGroupsInFilter(groupIds) {
      if (groupIds.length === 0 && hasIncludedGroupsInFilter()) {
        var config = Utils.getIn($scope, ['filter', 'config']);
        delete config.groupIds; // todo: deleteIn($scope, ['filter', 'config', 'groupIds'])
      } else {
        Utils.setIn($scope, ['filter', 'config', 'groupIds'], groupIds, {
          force: true
        });
      }
    }

    // groups excluded in filter
    function getExcludedGroupsInFilter() {
      var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        alt = _ref15.alt;
      var pgFilter = getExcludedPeopleOrGroupsInFilter({
        alt: false
      });
      if (!!pgFilter && hasGroupIds(pgFilter)) {
        return getGroupIds(pgFilter);
      }
      return alt;
    }
    function setExcludedGroupsInFilter(groupIds) {
      if (hasExcludedPeopleOrGroupsInFilter()) {
        var pgFilter = getExcludedPeopleOrGroupsInFilter();
        setExcludedPeopleOrGroupsInFilter({
          personIds: getPersonIds(pgFilter),
          groupIds: groupIds
        });
      } else {
        pushExcludedPeopleOrGroupsInFilter({
          groupIds: groupIds
        });
      }
    }

    // verbs included in filter
    function getIncludedVerbsInFilter() {
      var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        alt = _ref16.alt;
      return Utils.getIn($scope, ['filter', 'config', 'verbIds', 'ids'], {
        alt: alt
      });
    }
    function hasIncludedVerbsInFilter() {
      return !!getIncludedVerbsInFilter({
        alt: false
      });
    }
    function setIncludedVerbsInFilter(verbIds) {
      if (verbIds.length === 0 && hasIncludedVerbsInFilter()) {
        var config = Utils.getIn($scope, ['filter', 'config']);
        delete config.verbIds; // todo: deleteIn($scope, ['filter', 'config', 'verbIds'])
      } else {
        Utils.setIn($scope, ['filter', 'config', 'verbIds', 'ids'], verbIds, {
          force: true
        });
      }
    }

    // verbs excluded in filter
    function getExcludedVerbsInFilter() {
      var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        alt = _ref17.alt;
      var notOrFilter = getNotOrFilter({
        alt: []
      });
      var verbFilter = notOrFilter.find(hasVerbIds);
      return verbFilter ? getVerbIds(verbFilter) : alt;
    }
    function hasExcludedVerbsInFilter() {
      return !!getExcludedVerbsInFilter({
        alt: false
      });
    }
    function remFirstExcludedVerbsInFilter() {
      if (hasExcludedVerbsInFilter()) {
        var notOrFilter = getNotOrFilter({
          alt: []
        });
        var verbFilterIndex = notOrFilter.findIndex(hasVerbIds); // todo: use findIndexOfExcludedVerbsInFilter
        setNotOrFilter(notOrFilter.slice(0, verbFilterIndex).concat(notOrFilter.slice(verbFilterIndex + 1)));
      }
    }
    function pushExcludedVerbsInFilter(ids) {
      var notOrFilter = getNotOrFilter({
        alt: []
      });
      var verbIds = putVerbIds({}, ids);
      setNotOrFilter([verbIds].concat(_toConsumableArray(notOrFilter)));
    }
    function setExcludedVerbsInFilter(ids) {
      remFirstExcludedVerbsInFilter();
      pushExcludedVerbsInFilter(ids);
    }

    // -------------------------------
    // Activities Util
    // -------------------------------
    // activity util setup
    function initActivityUtils() {
      Utils.setIn($scope, ['utils', 'activities'], {
        typeaheadSelection: '',
        currentSelection: null,
        selected: [],
        excludeSelection: false,
        selectionState: {}
      });

      // begin activity-util ui-methods
      // activity data
      Utils.setIn($scope, ['getActivityName'], getActivityName);
      // activity typeahead/selection
      Utils.setIn($scope, ['getActivityTypeahead'], getActivityTypeahead);
      Utils.setIn($scope, ['activitySelected'], activitySelected);
      // activity-selection icons
      Utils.setIn($scope, ['removeIncludedActivity'], removeIncludedActivity);
      Utils.setIn($scope, ['removeExcludedActivity'], removeExcludedActivity);
      Utils.setIn($scope, ['includeActivityById'], includeActivityById);
      Utils.setIn($scope, ['excludeActivityById'], excludeActivityById);
      Utils.setIn($scope, ['setActivitySelectionIconVisibility'], setActivitySelectionIconVisibility);
      Utils.setIn($scope, ['getActivitySelectionIconVisibility'], getActivitySelectionIconVisibility);
      // end activity-util ui-methods

      var name = Utils.getIn($scope, ['utils', 'activities', 'currentSelection', 'name']);
      Utils.setIn($scope, ['utils', 'activities', 'typeaheadSelection'], name || '');
      var id = Utils.getIn($scope, ['utils', 'activities', 'currentSelection', 'activityId']);
      getActivityTypeahead(id); // question: is this necessary?
      prepareSelectedActivities();
    }

    // begin activity-util ui-methods
    // activity data
    function getActivityName(activityId) {
      return Utils.getIn($scope, ['activities', activityId, 'name'], {
        alt: activityId
      });
    }

    // activity typeahead/selection
    function getActivityTypeahead(val) {
      return getFilterTypeahead('activityIds', val);
    }
    function activitySelected(item) {
      Utils.setIn($scope, ['utils', 'activities', 'currentSelection'], item);
      selectIncludedActivity();
      clearActivity();
    }

    // activity-selection icons
    function removeIncludedActivity(activityId) {
      setActivitySelectionIncluded(activityId, false);
      setIncludedActivitiesInFilter(getActivityIncludedPredicate());
    }
    function removeExcludedActivity(activityId) {
      setActivitySelectionExcluded(activityId, false);
      setExcludedActivitiesInFilter(getActivityExcludedPredicate());
    }
    function includeActivityById(activityId) {
      setActivitySelectionIncluded(activityId, true);
      setActivitySelectionExcluded(activityId, false);
      setActivitySelectionIconVisibility(activityId, false);
      setIncludedActivitiesInFilter(getActivityIncludedPredicate());
      setExcludedActivitiesInFilter(getActivityExcludedPredicate());
    }
    function excludeActivityById(activityId) {
      setActivitySelectionIncluded(activityId, false);
      setActivitySelectionExcluded(activityId, true);
      setActivitySelectionIconVisibility(activityId, false);
      setIncludedActivitiesInFilter(getActivityIncludedPredicate());
      setExcludedActivitiesInFilter(getActivityExcludedPredicate());
    }
    function setActivitySelectionIconVisibility(activityId, b) {
      setActivitySelectionState('showIcons', activityId, b);
    }
    function getActivitySelectionIconVisibility(activityId) {
      return getActivityStatePredicate('showIcons').includes(activityId);
    }
    // end activity-util ui-methods

    // begin activity-util helper methods
    // activity util setup
    // prepare selected activities for ui--this entails getting any included-activities on the filter config
    // then merging with any included-activities selected in the ui state (m.m. excluded activities)
    function prepareSelectedActivities() {
      prepareIncludedActivities();
      prepareExcludedActivities();
    }
    function prepareIncludedActivities() {
      var activityIds = getIncludedActivitiesInFilter({
        alt: []
      });
      // const selectedIds = getActivityIncludedPredicate();
      // const activityIds = Array.from(selectedIds.reduce((s, id) => s.add(id), new Set(filterIds)));
      setIncludedActivitiesInFilter(activityIds);
      setActivityIncludedPredicate(activityIds);
    }
    function prepareExcludedActivities() {
      var activityIds = getExcludedActivitiesInFilter({
        alt: []
      });
      // const selectedIds = getActivityExcludedPredicate();
      // const activityIds = Array.from(selectedIds.reduce((s, id) => s.add(id), new Set(filterIds)));
      setExcludedActivitiesInFilter(activityIds);
      setActivityExcludedPredicate(activityIds);
    }

    // activity typeahead/selection
    // add an included-activity to the filter config and to the ui state
    function selectIncludedActivity(activity) {
      if (!activity && Utils.getIn($scope, ['utils', 'activities', 'currentSelection'])) {
        return selectIncludedActivity(Utils.getIn($scope, ['utils', 'activities', 'currentSelection']));
      }
      setActivitySelectionIconVisibility(activity.id, false);
      setActivitySelectionIncluded(activity.id, true);
      setIncludedActivitiesInFilter(getActivityIncludedPredicate());
    }

    // remove selected activity from state
    function clearActivity() {
      Utils.setIn($scope, ['utils', 'activities', 'currentSelection'], null);
      clearActivityTypeahead();
    }

    // clear any text from the activity typeahead
    function clearActivityTypeahead() {
      Utils.setIn($scope, ['utils', 'activities', 'typeaheadSelection'], '');
      getActivityTypeahead('');
    }

    // activity-util selection-state helpers
    // todo: generalize these pred. methods
    // each member of utils.activities.selectionState is a list of activity-ids representing a predicate that
    // describes the set of activities in a given state
    function setActivityStatePredicate(s, ids) {
      return Utils.setIn($scope, ['utils', 'activities', 'selectionState', s], ids, {
        force: true
      });
    }
    function getActivityStatePredicate(s) {
      return Utils.getIn($scope, ['utils', 'activities', 'selectionState', s], {
        alt: []
      });
    }

    // is the activity with the given id in state s
    function testActivitySelectionState(s, id) {
      return getActivityStatePredicate(s).includes(id);
    }

    // assert that the activity with the given id is in state s (or not, depending on b)
    function setActivitySelectionState(s, id, b) {
      var statePredicate = getActivityStatePredicate(s);
      if (b && !testActivitySelectionState(s, id)) {
        statePredicate.push(id);
      }
      if (!b && testActivitySelectionState(s, id)) {
        statePredicate = statePredicate.filter(function (x) {
          return x !== id;
        });
      }
      setActivityStatePredicate(s, statePredicate);
    }

    // activity-selection icons use the following state methods
    // include activity
    function setActivitySelectionIncluded(activityId, b) {
      setActivitySelectionState('included', activityId, b);
    }
    function setActivityIncludedPredicate(activityIds) {
      setActivityStatePredicate('included', activityIds);
    }
    function getActivityIncludedPredicate() {
      return getActivityStatePredicate('included');
    }

    // exclude activity
    function setActivitySelectionExcluded(activityId, b) {
      setActivitySelectionState('excluded', activityId, b);
    }
    function setActivityExcludedPredicate(activityIds) {
      setActivityStatePredicate('excluded', activityIds);
    }
    function getActivityExcludedPredicate() {
      return getActivityStatePredicate('excluded');
    }
    // end activity-util helper methods

    // -------------------------------
    // People Util
    // -------------------------------
    // people util setup
    function initPeopleUtils() {
      Utils.setIn($scope, ['utils', 'people'], {
        typeaheadSelection: '',
        currentSelection: null,
        selected: [],
        excludeSelection: false,
        selectionState: {}
      });

      // begin people-util ui-methods
      // people data
      Utils.setIn($scope, ['getPersonName'], getPersonName);
      // person typeahead/selection
      Utils.setIn($scope, ['getPersonTypeahead'], getPersonTypeahead);
      Utils.setIn($scope, ['personSelected'], personSelected);
      // person-selection icons
      Utils.setIn($scope, ['removeIncludedPerson'], removeIncludedPerson);
      Utils.setIn($scope, ['removeExcludedPerson'], removeExcludedPerson);
      Utils.setIn($scope, ['includePersonById'], includePersonById);
      Utils.setIn($scope, ['excludePersonById'], excludePersonById);
      Utils.setIn($scope, ['setPersonSelectionIconVisibility'], setPersonSelectionIconVisibility);
      Utils.setIn($scope, ['getPersonSelectionIconVisibility'], getPersonSelectionIconVisibility);
      Utils.setIn($scope, ['people'], {});
      var name = Utils.getIn($scope, ['utils', 'people', 'currentSelection', 'name']);
      Utils.setIn($scope, ['utils', 'people', 'typeaheadSelection'], name || '');
      getPersonTypeahead(name);
      // const id = Utils.getIn($scope, ['utils', 'people', 'currentSelection', 'personId'])// question: save id as well?
      // getPersonTypeahead(id);
      prepareSelectedPeople();
    }

    // begin person-util ui-methods
    // person data
    function getPersonName(personId) {
      return Utils.getIn($scope, ['people', personId, 'name'], {
        alt: personId
      });
    }

    // person typeahead/selection
    function getPersonTypeahead(val) {
      return getFilterTypeahead('personIds', val);
    }
    function personSelected(item) {
      Utils.setIn($scope, ['utils', 'people', 'currentSelection'], item);
      Utils.setIn($scope, ['people', item.id], item);
      selectIncludedPerson();
      clearPerson();
    }

    // person-selection icons
    function removeIncludedPerson(personId) {
      setPersonSelectionIncluded(personId, false);
      setIncludedPeopleInFilter(getPersonIncludedPredicate());
    }
    function removeExcludedPerson(personId) {
      setPersonSelectionExcluded(personId, false);
      setExcludedPeopleInFilter(getPersonExcludedPredicate());
    }
    function includePersonById(personId) {
      setPersonSelectionIncluded(personId, true);
      setPersonSelectionExcluded(personId, false);
      setPersonSelectionIconVisibility(personId, false);
      setIncludedPeopleInFilter(getPersonIncludedPredicate());
      setExcludedPeopleInFilter(getPersonExcludedPredicate());
    }
    function excludePersonById(personId) {
      setPersonSelectionIncluded(personId, false);
      setPersonSelectionExcluded(personId, true);
      setPersonSelectionIconVisibility(personId, false);
      setIncludedPeopleInFilter(getPersonIncludedPredicate());
      setExcludedPeopleInFilter(getPersonExcludedPredicate());
    }
    function setPersonSelectionIconVisibility(personId, b) {
      setPersonSelectionState('showIcons', personId, b);
    }
    function getPersonSelectionIconVisibility(personId) {
      return getPersonStatePredicate('showIcons').includes(personId);
    }
    // end people-util ui-methods

    // begin people-util helper methods
    // person util setup
    // prepare selected people for ui--this entails getting any included-people on the filter config
    // then merging with any included-people selected in the ui state (m.m. excluded-people)
    function prepareSelectedPeople() {
      prepareIncludedPeople();
      prepareExcludedPeople();
    }
    function prepareIncludedPeople() {
      var filterIds = getIncludedPeopleInFilter({
        alt: []
      });
      var selectedIds = getPersonIncludedPredicate();
      var personIds = Array.from(selectedIds.reduce(function (s, id) {
        return s.add(id);
      }, new Set(filterIds)));
      setIncludedPeopleInFilter(personIds);
      setPersonIncludedPredicate(personIds);
    }
    function prepareExcludedPeople() {
      var filterIds = getExcludedPeopleInFilter({
        alt: []
      });
      var selectedIds = getPersonExcludedPredicate();
      var personIds = Array.from(selectedIds.reduce(function (s, id) {
        return s.add(id);
      }, new Set(filterIds)));
      setExcludedPeopleInFilter(personIds);
      setPersonExcludedPredicate(personIds);
    }

    // person typeahead/selection
    // add an included-person to the filter config and to the ui state
    function selectIncludedPerson(person) {
      if (!person && Utils.getIn($scope, ['utils', 'people', 'currentSelection'])) {
        return selectIncludedPerson(Utils.getIn($scope, ['utils', 'people', 'currentSelection']));
      }
      setPersonSelectionIconVisibility(person.id, false);
      setPersonSelectionIncluded(person.id, true);
      setIncludedPeopleInFilter(getPersonIncludedPredicate());
    }

    // remove selected person from state
    function clearPerson() {
      Utils.setIn($scope, ['utils', 'people', 'currentSelection'], null);
      clearPersonTypeahead();
    }

    // clear any text from the person typeahead
    function clearPersonTypeahead() {
      Utils.setIn($scope, ['utils', 'people', 'typeaheadSelection'], '');
      getPersonTypeahead('');
    }

    // person-util selection-state helpers
    // todo: generalize these pred. methods
    // each member of utils.person.selectionState is a list of person-ids representing a predicate that
    // describes the set of people in a given state
    function setPersonStatePredicate(s, ids) {
      return Utils.setIn($scope, ['utils', 'people', 'selectionState', s], ids, {
        force: true
      });
    }
    function getPersonStatePredicate(s) {
      return Utils.getIn($scope, ['utils', 'people', 'selectionState', s], {
        alt: []
      });
    }

    // is the person with the given id in state s
    function testPersonSelectionState(s, id) {
      return getPersonStatePredicate(s).includes(id);
    }

    // assert that the person with the given id is in state s (or not, depending on b)
    function setPersonSelectionState(s, id, b) {
      var statePredicate = getPersonStatePredicate(s);
      if (b && !testPersonSelectionState(s, id)) {
        statePredicate.push(id);
      }
      if (!b && testPersonSelectionState(s, id)) {
        statePredicate = statePredicate.filter(function (x) {
          return x !== id;
        });
      }
      setPersonStatePredicate(s, statePredicate);
    }

    // person-selection icons use the following state methods
    // include person
    function setPersonSelectionIncluded(personId, b) {
      setPersonSelectionState('included', personId, b);
    }
    function setPersonIncludedPredicate(personIds) {
      setPersonStatePredicate('included', personIds);
    }
    function getPersonIncludedPredicate() {
      return getPersonStatePredicate('included');
    }

    // exclude person
    function setPersonSelectionExcluded(personId, b) {
      setPersonSelectionState('excluded', personId, b);
    }
    function setPersonExcludedPredicate(personIds) {
      setPersonStatePredicate('excluded', personIds);
    }
    function getPersonExcludedPredicate() {
      return getPersonStatePredicate('excluded');
    }
    // end people-util helper methods

    // -------------------------------
    // Groups Util
    // -------------------------------
    // groups util setup
    function initGroupsUtils() {
      Utils.setIn($scope, ['utils', 'groups'], {
        typeaheadSelection: '',
        currentSelection: null,
        selected: [],
        excludeSelection: false,
        selectionState: {}
      });

      // begin group-util ui-methods
      // group data
      Utils.setIn($scope, ['getGroupName'], getGroupName);
      // person typeahead/selection
      Utils.setIn($scope, ['getGroupTypeahead'], getGroupTypeahead);
      Utils.setIn($scope, ['groupSelected'], groupSelected);
      // group-selection icons
      Utils.setIn($scope, ['removeIncludedGroup'], removeIncludedGroup);
      Utils.setIn($scope, ['removeExcludedGroup'], removeExcludedGroup);
      Utils.setIn($scope, ['includeGroupById'], includeGroupById);
      Utils.setIn($scope, ['excludeGroupById'], excludeGroupById);
      Utils.setIn($scope, ['setGroupSelectionIconVisibility'], setGroupSelectionIconVisibility);
      Utils.setIn($scope, ['getGroupSelectionIconVisibility'], getGroupSelectionIconVisibility);
      Utils.setIn($scope, ['groups'], {});
      var name = Utils.getIn($scope, ['utils', 'groups', 'currentSelection', 'name']);
      Utils.setIn($scope, ['utils', 'groups', 'typeaheadSelection'], name || '');
      getGroupTypeahead(name);
      // const id = Utils.getIn($scope, ['utils', 'groups', 'currentSelection', 'groupId'])// question: save id as well?
      // getGroupTypeahead(id);
      prepareSelectedGroups();
    }

    // begin group-util ui-methods
    // group data
    function getGroupName(groupId) {
      return Utils.getIn($scope, ['groups', groupId, 'name'], {
        alt: groupId
      });
    }

    // group typeahead/selection
    function getGroupTypeahead(val) {
      return getFilterTypeahead('groupIds', val);
    }
    function groupSelected(item) {
      Utils.setIn($scope, ['utils', 'groups', 'currentSelection'], item);
      Utils.setIn($scope, ['groups', item.id], item);
      selectIncludedGroup();
      clearGroup();
    }

    // group-selection icons
    function removeIncludedGroup(groupId) {
      setGroupSelectionIncluded(groupId, false);
      setIncludedGroupsInFilter(getGroupIncludedPredicate());
    }
    function removeExcludedGroup(groupId) {
      setGroupSelectionExcluded(groupId, false);
      setExcludedGroupsInFilter(getPersonExcludedPredicate());
    }
    function includeGroupById(groupId) {
      setGroupSelectionIncluded(groupId, true);
      setGroupSelectionExcluded(groupId, false);
      setGroupSelectionIconVisibility(groupId, false);
      setIncludedGroupsInFilter(getGroupIncludedPredicate());
      setExcludedGroupsInFilter(getGroupExcludedPredicate());
    }
    function excludeGroupById(groupId) {
      setGroupSelectionIncluded(groupId, false);
      setGroupSelectionExcluded(groupId, true);
      setGroupSelectionIconVisibility(groupId, false);
      setIncludedGroupsInFilter(getGroupIncludedPredicate());
      setExcludedGroupsInFilter(getGroupExcludedPredicate());
    }
    function setGroupSelectionIconVisibility(groupId, b) {
      setGroupSelectionState('showIcons', groupId, b);
    }
    function getGroupSelectionIconVisibility(groupId) {
      return getGroupStatePredicate('showIcons').includes(groupId);
    }
    // end groups-util ui-methods

    // begin groups-util helper methods
    // groups util setup
    // prepare selected groups for ui--this entails getting any included-groups on the filter config
    // then merging with any included-groups selected in the ui state (m.m. excluded-groups)
    function prepareSelectedGroups() {
      prepareIncludedGroups();
      prepareExcludedGroups();
    }
    function prepareIncludedGroups() {
      var filterIds = getIncludedGroupsInFilter({
        alt: []
      });
      var selectedIds = getGroupIncludedPredicate();
      var groupIds = Array.from(selectedIds.reduce(function (s, id) {
        return s.add(id);
      }, new Set(filterIds)));
      setIncludedGroupsInFilter(groupIds);
      setGroupIncludedPredicate(groupIds);
    }
    function prepareExcludedGroups() {
      var filterIds = getExcludedGroupsInFilter({
        alt: []
      });
      var selectedIds = getGroupExcludedPredicate();
      var groupIds = Array.from(selectedIds.reduce(function (s, id) {
        return s.add(id);
      }, new Set(filterIds)));
      setExcludedGroupsInFilter(groupIds);
      setGroupExcludedPredicate(groupIds);
    }

    // group typeahead/selection
    // add an included-group to the filter config and to the ui state
    function selectIncludedGroup(group) {
      if (!group && Utils.getIn($scope, ['utils', 'groups', 'currentSelection'])) {
        return selectIncludedGroup(Utils.getIn($scope, ['utils', 'groups', 'currentSelection']));
      }
      setGroupSelectionIconVisibility(group.id, false);
      setGroupSelectionIncluded(group.id, true);
      setIncludedGroupsInFilter(getGroupIncludedPredicate());
    }

    // remove selected group from state
    function clearGroup() {
      Utils.setIn($scope, ['utils', 'groups', 'currentSelection'], null);
      clearGroupTypeahead();
    }

    // clear any text from the group typeahead
    function clearGroupTypeahead() {
      Utils.setIn($scope, ['utils', 'groups', 'typeaheadSelection'], '');
      getGroupTypeahead('');
    }

    // groups-util selection-state helpers
    // todo: generalize these pred. methods
    // each member of utils.groups.selectionState is a list of group-ids representing a predicate that
    // describes the set of groups in a given state
    function setGroupStatePredicate(s, ids) {
      return Utils.setIn($scope, ['utils', 'groups', 'selectionState', s], ids, {
        force: true
      });
    }
    function getGroupStatePredicate(s) {
      return Utils.getIn($scope, ['utils', 'groups', 'selectionState', s], {
        alt: []
      });
    }

    // is the group with the given id in state s
    function testGroupSelectionState(s, id) {
      return getGroupStatePredicate(s).includes(id);
    }

    // assert that the group with the given id is in state s (or not, depending on b)
    function setGroupSelectionState(s, id, b) {
      var statePredicate = getGroupStatePredicate(s);
      if (b && !testGroupSelectionState(s, id)) {
        statePredicate.push(id);
      }
      if (!b && testGroupSelectionState(s, id)) {
        statePredicate = statePredicate.filter(function (x) {
          return x !== id;
        });
      }
      setGroupStatePredicate(s, statePredicate);
    }

    // group-selection icons use the following state methods
    // include group
    function setGroupSelectionIncluded(groupId, b) {
      setGroupSelectionState('included', groupId, b);
    }
    function setGroupIncludedPredicate(groupIds) {
      setGroupStatePredicate('included', groupIds);
    }
    function getGroupIncludedPredicate() {
      return getGroupStatePredicate('included');
    }

    // exclude group
    function setGroupSelectionExcluded(groupId, b) {
      setGroupSelectionState('excluded', groupId, b);
    }
    function setGroupExcludedPredicate(groupIds) {
      setGroupStatePredicate('excluded', groupIds);
    }
    function getGroupExcludedPredicate() {
      return getGroupStatePredicate('excluded');
    }
    // end people-util helper methods

    // -------------------------------
    // Verbs Util
    // -------------------------------
    // verb util setup
    function initVerbUtils() {
      Utils.setIn($scope, ['utils', 'verbs'], {
        typeaheadSelection: '',
        currentSelection: null,
        selected: [],
        excludeSelection: false,
        selectionState: {}
      });

      // begin verb-util ui-methods
      // verb data
      Utils.setIn($scope, ['getVerbName'], getVerbName);
      // verb typeahead/selection
      Utils.setIn($scope, ['getVerbTypeahead'], getVerbTypeahead);
      Utils.setIn($scope, ['verbSelected'], verbSelected);
      // verb-selection icons
      Utils.setIn($scope, ['removeIncludedVerb'], removeIncludedVerb);
      Utils.setIn($scope, ['removeExcludedVerb'], removeExcludedVerb);
      Utils.setIn($scope, ['includeVerbById'], includeVerbById);
      Utils.setIn($scope, ['excludeVerbById'], excludeVerbById);
      Utils.setIn($scope, ['setVerbSelectionIconVisibility'], setVerbSelectionIconVisibility);
      Utils.setIn($scope, ['getVerbSelectionIconVisibility'], getVerbSelectionIconVisibility);
      // end verb-util ui-methods

      Utils.setIn($scope, ['verbs'], {});
      var name = Utils.getIn($scope, ['utils', 'verbs', 'currentSelection', 'name']);
      Utils.setIn($scope, ['utils', 'verbs', 'typeaheadSelection'], name || '');
      var id = Utils.getIn($scope, ['utils', 'verbs', 'currentSelection', 'verbId']);
      getVerbTypeahead(id); // question: is this necessary?
      prepareSelectedVerbs();
    }

    // begin verb-util ui-methods
    // verb data
    function getVerbName(verbId) {
      var display = Utils.getIn($scope, ['verbs', verbId, 'display'], {
        alt: verbId
      });
      return Utils.getIn($scope, ['verbs', verbId, 'name'], {
        alt: display
      });
    }

    // verb typeahead/selection
    function getVerbTypeahead(val) {
      return getFilterTypeahead('verbIds', val);
    }
    function verbSelected(item) {
      Utils.setIn($scope, ['utils', 'verbs', 'currentSelection'], item);
      Utils.setIn($scope, ['verbs', item.id], item);
      selectIncludedVerb();
      clearVerb();
    }

    // verb-selection icons
    function removeIncludedVerb(verbId) {
      setVerbSelectionIncluded(verbId, false);
      setIncludedVerbsInFilter(getVerbIncludedPredicate());
    }
    function removeExcludedVerb(verbId) {
      setVerbSelectionExcluded(verbId, false);
      setExcludedVerbsInFilter(getVerbExcludedPredicate());
    }
    function includeVerbById(verbId) {
      setVerbSelectionIncluded(verbId, true);
      setVerbSelectionExcluded(verbId, false);
      setVerbSelectionIconVisibility(verbId, false);
      setIncludedVerbsInFilter(getVerbIncludedPredicate());
      setExcludedVerbsInFilter(getVerbExcludedPredicate());
    }
    function excludeVerbById(verbId) {
      setVerbSelectionIncluded(verbId, false);
      setVerbSelectionExcluded(verbId, true);
      setVerbSelectionIconVisibility(verbId, false);
      setIncludedVerbsInFilter(getVerbIncludedPredicate());
      setExcludedVerbsInFilter(getVerbExcludedPredicate());
    }
    function setVerbSelectionIconVisibility(verbId, b) {
      setVerbSelectionState('showIcons', verbId, b);
    }
    function getVerbSelectionIconVisibility(verbId) {
      return getVerbStatePredicate('showIcons').includes(verbId);
    }
    // end verb-util ui-methods

    // begin verb-util helper methods
    // verb util setup
    // prepare selected verbs for ui--this entails getting any included-verbs on the filter config
    // then merging with any included-verbs selected in the ui state (m.m. excluded verbs)
    function prepareSelectedVerbs() {
      prepareIncludedVerbs();
      prepareExcludedVerbs();
    }
    function prepareIncludedVerbs() {
      var filterIds = getIncludedVerbsInFilter({
        alt: []
      });
      var selectedIds = getVerbIncludedPredicate();
      var verbIds = Array.from(selectedIds.reduce(function (s, id) {
        return s.add(id);
      }, new Set(filterIds)));
      setIncludedVerbsInFilter(verbIds);
      setVerbIncludedPredicate(verbIds);
    }
    function prepareExcludedVerbs() {
      var filterIds = getExcludedVerbsInFilter({
        alt: []
      });
      var selectedIds = getVerbExcludedPredicate();
      var verbIds = Array.from(selectedIds.reduce(function (s, id) {
        return s.add(id);
      }, new Set(filterIds)));
      setExcludedVerbsInFilter(verbIds);
      setVerbExcludedPredicate(verbIds);
    }

    // verb typeahead/selection
    // add an included-verb to the filter config and to the ui state
    function selectIncludedVerb(verb) {
      if (!verb && Utils.getIn($scope, ['utils', 'verbs', 'currentSelection'])) {
        return selectIncludedVerb(Utils.getIn($scope, ['utils', 'verbs', 'currentSelection']));
      }
      setVerbSelectionIconVisibility(verb.id, false);
      setVerbSelectionIncluded(verb.id, true);
      setIncludedVerbsInFilter(getVerbIncludedPredicate());
    }

    // remove selected verb from state
    function clearVerb() {
      Utils.setIn($scope, ['utils', 'verbs', 'currentSelection'], null);
      clearVerbTypeahead();
    }

    // clear any text from the verb typeahead
    function clearVerbTypeahead() {
      Utils.setIn($scope, ['utils', 'verbs', 'typeaheadSelection'], '');
      getVerbTypeahead('');
    }

    // verb-util selection-state helpers
    // todo: generalize these pred. methods
    // each member of utils.verbs.selectionState is a list of verb-ids representing a predicate that
    // describes the set of verbs in a given state
    function setVerbStatePredicate(s, ids) {
      return Utils.setIn($scope, ['utils', 'verbs', 'selectionState', s], ids, {
        force: true
      });
    }
    function getVerbStatePredicate(s) {
      return Utils.getIn($scope, ['utils', 'verbs', 'selectionState', s], {
        alt: []
      });
    }

    // is the verb with the given id in state s
    function testVerbSelectionState(s, id) {
      return getVerbStatePredicate(s).includes(id);
    }

    // assert that the verb with the given id is in state s (or not, depending on b)
    function setVerbSelectionState(s, id, b) {
      var statePredicate = getVerbStatePredicate(s);
      if (b && !testVerbSelectionState(s, id)) {
        statePredicate.push(id);
      }
      if (!b && testVerbSelectionState(s, id)) {
        statePredicate = statePredicate.filter(function (x) {
          return x !== id;
        });
      }
      setVerbStatePredicate(s, statePredicate);
    }

    // verb-selection icons use the following state methods
    // include verb
    function setVerbSelectionIncluded(verbId, b) {
      setVerbSelectionState('included', verbId, b);
    }
    function setVerbIncludedPredicate(verbId) {
      setVerbStatePredicate('included', verbId);
    }
    function getVerbIncludedPredicate() {
      return getVerbStatePredicate('included');
    }

    // exclude verb
    function setVerbSelectionExcluded(verbId, b) {
      setVerbSelectionState('excluded', verbId, b);
    }
    function setVerbExcludedPredicate(verbIds) {
      setVerbStatePredicate('excluded', verbIds);
    }
    function getVerbExcludedPredicate() {
      return getVerbStatePredicate('excluded');
    }
    // end verb-util helper methods

    // -------------------------------
    // Dates Util
    // -------------------------------
    // todo

    // -------------------------------
    // Permissions Util
    // -------------------------------
    function initPermissionsUtil() {
      Utils.setIn($scope, ['addPermission'], addPermission);
      Utils.setIn($scope, ['removePermission'], removePermission);
      Utils.setIn($scope, ['havePermissionsChanged'], havePermissionsChanged);
    }
    function addPermission(target) {
      var newPermission = {
        value: 'filter',
        entityId: Utils.getIn($scope, ['filter', 'id'])
      };
      if (_.has(target, 'childGroupIds')) {
        editGroups.push(target);
        editPermissions.push(_.extend(newPermission, {
          groupId: target.id
        }));
      } else {
        editPeople.push(target);
        editPermissions.push(_.extend(newPermission, {
          personId: target.id
        }));
      }
      Utils.setIn($scope, ['editPeopleAndGroups'], [].concat(editPeople, editGroups));
      Utils.setIn($scope, ['permissionsChanged'], havePermissionsChanged());
      Utils.setIn($scope, ['filterChanged'], true);
    }
    function removePermission(target) {
      if (_.has(target, 'childGroupIds')) {
        editGroups = _.reject(editGroups, function (o) {
          return o.id === target.id;
        });
        editPermissions = _.reject(editPermissions, function (p) {
          return p.groupId === target.id;
        });
      } else {
        editPeople = _.reject(editPeople, function (o) {
          return o.id === target.id;
        });
        editPermissions = _.reject(editPermissions, function (p) {
          return p.personId === target.id;
        });
      }
      Utils.setIn($scope, ['editPeopleAndGroups'], [].concat(editPeople, editGroups));
      Utils.setIn($scope, ['permissionsChanged'], havePermissionsChanged());
      Utils.setIn($scope, ['filterChanged'], true);
    }
    function havePermissionsChanged() {
      var id = Utils.getIn($scope, ['filter', 'id']);
      return !_.isEqual(_.pluck(PermissionSvc.getGroups(id), 'id'), _.pluck(editGroups, 'id')) || !_.isEqual(_.pluck(PermissionSvc.getPeople(id), 'id'), _.pluck(editPeople, 'id'));
    }

    // -------------------------------
    // Advanced Editor
    // -------------------------------
    // todo: initAdvancedEditorControls
    $scope.showAdvanced = function () {
      $scope.advancedConfig = true;
      setEditor();
    };
    $scope.aceLoaded = function (_editor) {
      $scope.editor = _editor;
      var session = _editor.getSession();
      session.setMode("ace/mode/json");
      session.setTabSize(2);
      session.setUseSoftTabs(true);
    };
    $scope.aceChanged = _.debounce($scope.$safeApply.bind($scope, function () {
      updateFilterFromAceEditor();
      // note: may need to 'prepareSelectedFilters'
      // note: in that case, might also need to refresh editor data (as below)
      //  and add option to overwrite selectionStates with new config
      // fetchEditorData(Utils.getIn($scope, ['filter'])).then(prepareSelectedFilters);
    }), 2000);
    function updateFilterFromAceEditor() {
      try {
        // Append the filterCategory and permissions that we removed in
        // the setEditor() function so we don't lose that data.
        var editorFilter = JSON.parse($scope.editor.getValue());
        editorFilter.filterCategory = $scope.filter.filterCategory;
        editorFilter.permissions = $scope.filter.permissions;
        $scope.filter = editorFilter;
      } catch (e) {
        if (e.name === 'SyntaxError') {
          return; // Disregard
        } else {
          throw e;
        }
      }
    }
    $scope.$watch('filter', _.debounce(function (oldValue, newValue) {
      //disable the save button until the filter is changed
      if ($scope.initializedFilterEditor || oldValue.filterCategory !== newValue.filterCategory) {
        $scope.filterChanged = true;
      }
    }, 100), true);

    // todo: InitAdvancedEditor

    // -------------------------------
    // Save Filter Modal
    // -------------------------------
    var openSaveModal = function openSaveModal(isCopy) {
      var id = !isCopy && $scope.filter.id,
        bodyText = '',
        confirmText = 'Save';
      if (id) {
        if ($scope.filter.reportCount) {
          var reportCount = $scope.filter.reportCount || 0;
          bodyText = "This will update the filter and the ".concat(reportCount, " report").concat(reportCount > 1 ? 's' : '', " it is used on. ");
          confirmText += ' and update all reports it is used on';
        }
      } else {
        bodyText = 'This will create a new filter. ';
      }
      bodyText += 'Are you sure?';
      var modal = {
        title: "Save custom filter: ".concat($scope.filter.name),
        body: bodyText,
        cancelBtn: 'Cancel',
        optionBtn: id ? 'Save as a copy instead' : null,
        confirmBtn: confirmText,
        confirm: function confirm() {
          if ($scope.filter.filterCategory && $scope.filter.filterCategory.name === $scope.noneCategory.name) {
            $scope.filter.filterCategory = null;
          }
          CustomFilters.save($scope.filter, {
            override: !isCopy
          }).then(function success(result) {
            $scope.filter = result;
            FilterRegistry.clear();
            FilterRegistry.add($scope.filter);
            if ($scope.permissionsChanged || !id) {
              _.forEach(editPermissions, function (p) {
                if (_.isUndefined(p.entityId)) {
                  p.entityId = $scope.filter.id;
                }
              });
              PermissionSvc.save($scope.filter.id, editPermissions, editPeople, editGroups).then(function savePermissionsSuccess(permissions) {
                $scope.filter.permissions = permissions;
              });
            }
            CardRegistry.clear();
            $location.path('/settings/filters');
          }, function failure(e) {
            $scope.error = e.message;
            Logger.error("Error saving filter, result " + e);
          });
        },
        cancel: function cancel() {},
        option: id ? function () {
          delete $scope.filter.id;
          delete $scope.filter.created;
          delete $scope.filter.updated;
          if ($scope.originalName === $scope.filter.name) {
            $scope.filter.name = "Copy of ".concat($scope.filter.name);
          }
          CustomFilters.save($scope.filter).then(function success(result) {
            $scope.filter = result;
            FilterRegistry.add($scope.filter);
            _.forEach(editPermissions, function (p) {
              if (_.isUndefined(p.entityId)) {
                p.entityId = $scope.filter.id;
              }
            });
            PermissionSvc.save($scope.filter.id, editPermissions, editPeople, editGroups).then(function savePermissionsSuccess(permissions) {
              $scope.filter.permissions = permissions;
            });
            $location.path('/settings/filters');
          }, function failure(e) {
            $scope.error = e.message;
            Logger.error("Error saving filter, result " + e);
          });
        } : null
      };
      if ($scope.originalEntity) {
        var originalWithoutCategory = _.clone($scope.originalEntity);
        delete originalWithoutCategory.filterCategory;
        delete originalWithoutCategory.filterCategoryName;
        delete originalWithoutCategory.permissions;
        var updateWithoutCategory = _.clone($scope.filter);
        delete updateWithoutCategory.filterCategory;
        delete updateWithoutCategory.filterCategoryName;
        delete updateWithoutCategory.permissions;
        var onlyCategoryChanged = !$scope.permissionsChanged && $scope.originalEntity.filterCategory !== $scope.filter.filterCategory && angular.equals(originalWithoutCategory, updateWithoutCategory);
        if (onlyCategoryChanged) {
          modal.confirm();
        } else {
          ConfirmModal.open($scope, modal);
        }
      } else {
        ConfirmModal.open($scope, modal);
      }
    };

    // todo: can this just be a function declaration?

    // -------------------------------
    // Validation
    // -------------------------------
    var validate = function validate() {
      var error = '';
      var config = $scope.filter.config;
      if (!$scope.filter.name) {
        error += "Please specify a Name for this filter. ";
      } else {
        if (!config.name) {
          config.name = $scope.filter.name;
        }
      }
      if (error) {
        $scope.error = error;
        return false;
      } else {
        $scope.error = '';
        return true;
      }
    };

    // -------------------------------
    // Preview
    // -------------------------------
    function initPreview() {
      Utils.setIn($scope, ['previewResponse'], []);
      Utils.setIn($scope, ['previewTotal'], 0);
      Utils.setIn($scope, ['previewLimit'], 10);
    }
    function fetchPreviewData() {
      var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref18$decorateStatem = _ref18.decorateStatements,
        decorateStatements = _ref18$decorateStatem === void 0 ? true : _ref18$decorateStatem;
      var filter = Utils.getIn($scope, ['filter', 'config'], {
        alt: {}
      });
      var limit = Utils.getIn($scope, ['previewLimit']);
      return $http.get(Api.url("/interactions/preview"), {
        params: {
          config: {
            filter: filter
          },
          limit: limit
        }
      }).then(function (response) {
        return {
          statements: response.data.results[0].result,
          total: response.data.totalHits
        };
      }).then(function (_ref19) {
        var statements = _ref19.statements,
          total = _ref19.total;
        return {
          statements: decorateStatements ? TinCanJS.getDecoratedStatements(statements) : statements,
          total: total
        };
      });
    }
    $scope.$watch('filter.config', _.debounce(function () {
      fetchPreviewData().then(function (_ref20) {
        var statements = _ref20.statements,
          total = _ref20.total;
        if (Array.isArray(statements)) {
          Utils.setIn($scope, ['previewResponse'], statements);
        }
        if (typeof total === 'number') {
          Utils.setIn($scope, ['previewTotal'], total);
        }
      });
    }, 1000), true);
  }]);
})();
